import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_VEHICLE_GROUPS](state, data) {
    state.allVehicleGroups = data
  },
  [types.SAVE_VEHICLE_GROUP](state, data) {
    state.vehicleGroup.push(data)
  },
}
